import { createAsyncThunk } from '@reduxjs/toolkit';
import { api } from '../../helpers/api_helper';
import { API_ENDPOINTS } from '../../constants/apiEndPoints';

export const getClicksData = createAsyncThunk(
    'analytics/getClicksData',
    async ({ profileId, page = 1, limit = 10 }, thunkAPI) => {
        try {
            
            
            const response = await api.get(API_ENDPOINTS.ANALYTICS.GET, {
                page,
                limit,
                profile_id: profileId,
                type: 'click',
            });
            console.log('Clicks data response:', response);
            return response;
        } catch (error) {
            console.error('Error fetching clicks data:', error);
            return thunkAPI.rejectWithValue(error.response?.data || { message: 'Failed to fetch clicks data' });
        }
    }
);

export const getEnquiriesData = createAsyncThunk(
    'analytics/getEnquiriesData',
    async ({ profileId, page = 1, limit = 10 }, thunkAPI) => {
        try {
            
            
            const response = await api.get(API_ENDPOINTS.ANALYTICS.GET, {
                page,
                limit,
                profile_id: profileId,
                type: 'enquiry',
                
            });
            console.log('Enquiries data response:', response);
            return response;
        } catch (error) {
            console.error('Error fetching enquiries data:', error);
            return thunkAPI.rejectWithValue(error.response?.data || { message: 'Failed to fetch enquiries data' });
        }
    }
);

export const getContactsAccessedData = createAsyncThunk(
    'analytics/getContactsAccessedData',
    async ({ profileId, page = 1, limit = 10 }, thunkAPI) => {
        try {
            
            
            const response = await api.get(API_ENDPOINTS.ANALYTICS.GET, {
                page,
                limit,
                profile_id: profileId,
                type: 'accessed_contacts',
                
            });
            console.log('Contacts accessed data response:', response);
            return response;
        } catch (error) {
            console.error('Error fetching contacts accessed data:', error);
            return thunkAPI.rejectWithValue(error.response?.data || { message: 'Failed to fetch contacts accessed data' });
        }
    }
);
